import { render, staticRenderFns } from "./uploadImgOne.vue?vue&type=template&id=68e7ce38&scoped=true&"
import script from "./uploadImgOne.vue?vue&type=script&lang=js&"
export * from "./uploadImgOne.vue?vue&type=script&lang=js&"
import style0 from "./uploadImgOne.vue?vue&type=style&index=0&id=68e7ce38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e7ce38",
  null
  
)

export default component.exports